import { render, staticRenderFns } from "./OrderModal.vue?vue&type=template&id=676dbff6&scoped=true&"
import script from "./OrderModal.vue?vue&type=script&lang=js&"
export * from "./OrderModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderModal.vue?vue&type=style&index=0&id=676dbff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676dbff6",
  null
  
)

export default component.exports